/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerWaitingForApprovalPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerWaitingForApprovalPage
);
